export interface MeasurementDisplayConfig {
  /** Non-derived variables safe to show before a measurement is started */
  rawVariables: string[];
  /** The variable shown as the "headline" value once the measurement is started */
  primaryVariable: string;
  primaryLabel: string;
  /** Unit suffix for the primary variable's displayed value, e.g. 'ºC' or 'MPa' */
  primaryUnit: string;
}

export const MEASUREMENT_TYPE_DISPLAY_CONFIG: Record<string, MeasurementDisplayConfig> = {
  TemperatureMeasurement: {
    rawVariables: ['temperature'],
    primaryVariable: 'temperature',
    primaryLabel: 'measurement.insight.curr_temperature',
    primaryUnit: 'ºC',
  },
  MaturityMeasurement: {
    rawVariables: ['temperature'],
    primaryVariable: 'strength',
    primaryLabel: 'measurement.insight.curr_strength',
    primaryUnit: 'MPa',
  },
};

/** Minutes between expected datapoints, per measurement type. Stand-in constant
 * until this becomes a DeviceProfile-driven value. */
export const MEASUREMENT_REPORTING_INTERVAL_MINUTES: Record<string, number> = {
  TemperatureMeasurement: 30,
  MaturityMeasurement: 30,
};

export function isMeasurementStarted(measurement: { started?: boolean }): boolean {
  return measurement.started !== false;
}

export type LivenessState = 'no-data' | 'green' | 'amber' | 'red';

export function getMeasurementLiveness(measurementType: string, lastTimestamp: Date | null | undefined): LivenessState {
  if (!lastTimestamp) return 'no-data';

  const intervalMinutes = MEASUREMENT_REPORTING_INTERVAL_MINUTES[measurementType] ?? 30;
  const ageMinutes = (Date.now() - new Date(lastTimestamp).getTime()) / 60000;

  if (ageMinutes <= intervalMinutes) return 'green';
  if (ageMinutes <= intervalMinutes * 2) return 'amber';
  return 'red';
}
